import { cloneDeep, findIndex } from "lodash";
import {
  GET_MODULE_SETTING_SUCCESS,
  UPDATE_MODULE_SETTING_SUCCESS,
} from "../constants";

export const initialState = {
  moduleSetting: undefined,
};
export const ModuleSettingsReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_MODULE_SETTING_SUCCESS: {
      return {
        ...state,
        moduleSetting: action.payload,
      };
    }

    case UPDATE_MODULE_SETTING_SUCCESS: {
      const tempcategories = cloneDeep(state.moduleSetting);
      const index = findIndex(
        tempcategories.data,
        (obj) => obj._id === action.payload._id
      );
      

      
      if (index !== -1) {
        tempcategories.data[index] = action.payload;
      }
      
      return {
        ...state,
        moduleSetting: tempcategories,
      };
    }

    default:
      return state;
  }
};
